import request from '@/utils/request'


const mode = () => {
  return sessionStorage.pcMicroStationMode === 'draft' ? 'draft' : 'new'
}

const Language = () => {
  return sessionStorage.pcMicroSiteEditLang == 'en' ? 'foren' : ''
}

/** 移动端 */
// 获取网站配置接口
export function getMobileConfig(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getMobileConfig`,
    method: 'get',
    params
  })
}

// 获取栏目列表
export function getColumnList(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getColumnList`,
    method: 'get',
    params
  })
}
// 获取栏目详情
export function getColumnInfo(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getColumnInfo`,
    method: 'get',
    params
  })
}
// 获取新闻详情
export function getNewsInfo(params) {
  return request({
    url: `/adminapi/Website${mode()}${Language()}/getNewsInfo`,
    method: 'get',
    params
  })
}


/** PC端 */
// 获取网站配置接口
export function getPcConfig(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getPcConfig`,
    method: 'get',
    params
  })
}
export function getPageList (params) {
  return request({
    url: `/adminapi/Webmodel${mode()}${Language()}/getPageList`,
    method: 'get',
    params
  })
}
export function webmodelDetail(params) {
  return request({
    url: `/adminapi/Webmodel${mode()}${Language()}/detail`,
    method: 'get',
    params
  })
}


// 获取栏目列表
export function getPcColumnList(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getPcColumnList`,
    method: 'get',
    params
  })
}
// 获取栏目详情
export function getPcColumnInfo(params) {
  return request({
    url: `/homeapi/Microsite${mode()}${Language()}/getPcColumnInfo`,
    method: 'get',
    params
  })
}
// 获取新闻详情
export function getPcNewsInfo(params) {
  return request({
    url: `/adminapi/Website${mode()}${Language()}/getPcNewsInfo`,
    method: 'get',
    params
  })
}

export function getEventInfo(params) {
  return request({
    url: `/adminapi/manage/getEventInfo`,
    method: 'get',
    params
  })
}
